<template>
  <section
    :class="scrollPosition > 64 && !showHeader && !isMobile ? ' nav -is-hidden' : 'nav' "
  >
    <div
      class="nav__list"
    >
      <ul class="desktop">
        <li
          v-for="(item, index) in menu"
          :key="index"
        >
          <nav-links
            :link="item"
          />
        </li>
      </ul>
      <ul
        v-if="!childrens "
        class="mobile"
      >
        <li
          v-for="(item, index) in menu"
          :key="index"
        >
          <nav-links
            :link="item"
            @nav-header="showElement(item)"
          />
        </li>
      </ul>
      <ul
        v-else
        class="just-mobile"
      >
        <li>
          <div class="mobile__links">
            <a
              class="links__anchor"
              @click="returnmenu()"
            >

              <svg>
                <use xlink:href="#icon-arrow2"></use>
              </svg>
              <span>
                {{ childrens.text }}
              </span>
            </a>
          </div>
          <ul class="child">
            <li
              v-for="(item, index) in childrens.children"
              :key="index"
            >
              <nav-links
                :link="item"
              />
            </li>
          </ul>
        </li>
      </ul>
      <ul class="nav__right">
        <li>
          <div class="top-link">
            <a href="/agences">
              <svg class="icon">
                <use
                  xlink:href="#icon-location"
                ></use>
              </svg>
              <div class="top-link-title">
                nos agences
              </div>
            </a>
          </div>
        </li>
        <li
          class="account-tab"
          :class="{'-open' : accountMenuOpen }"
        >
          <div
            class="top-link"
            :class="{'loggedin' : userIsLogged }"
          >
            <a
              @click="toggleLogin()"
              type="button"
            >
              <svg class="icon">
                <use
                  xlink:href="#icon-user"
                ></use>
              </svg>
              <div
                class="top-link-title"
                :class="{'-open' : accountMenuOpen }"
              >
                mon compte
              </div>
            </a>
            <!-- show if user is connected -->

            <div
              v-if="userIsLogged"
              class="open-submenu"
              @click="openAccountMenu()"
            >
              <svg class="arrow">
                <use xlink:href="#icon-arrow2"></use>
              </svg>
            </div>

            <div
              v-if="accountMenuOpen"
              :class="{'-open' : accountMenuOpen }"
              class="account-menu"
            >
              <div
                class="welcome-msg"
                v-if="userDetails.type == 1"
              >
                Bienvenue {{ userDetails.first_name }} {{ userDetails.last_name }}
              </div>
              <div
                v-else
                class="welcome-msg"
              >
                Bienvenue {{ userDetails.company_name }}
              </div>
              <div class="link">
                <a
                  href="/profile"
                  class="profile-link"
                >Voir mon profil</a>
              </div>
              <div class="logout">
                <a
                  class="logout-button"
                  @click="logout"
                >
                  <div class="btn-label">
                    {{ $t('commons.navigation.account.logout.title') }}
                  </div>
                  <svg class="icon-logout">
                    <use
                      xlink:href="#icon-logout"
                    ></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="top-link">
            <a href="/contact">
              <svg class="icon">
                <use
                  xlink:href="#icon-contact"
                ></use>
              </svg>
              <div class="top-link-title">
                contact
              </div>
            </a>
          </div>
          <light-box
            :visible="lightBoxOpen"
            :light="true"
            @close="toggleLogin()"
          >
            <pop-up-login />
          </light-box>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import NavLinks from './NavLinks'
import LightBox from '../LightBox'
import PopUpLogin from '../../Identification/PopUp/PopUpLogin'

export default {
  components: {
    NavLinks,
    LightBox,
    PopUpLogin,
  },
  data() {
    return {
      lightBoxOpen: false,
      childrens: null,
      scrollPosition: null,
      accountMenuOpen: false,
    }
  },
  computed: {
    ...mapState({
      userDetails: (state) => state.user.details,
    }),
    ...mapGetters({
      userIsLogged: 'auth/userIsLogged',
      ProfileRequested: 'user/isGetProfileRequested',
    }),
    menu() {
      return [...window.renaultRent.menu]
    },
    showHeader() {
      return this.$store.state.stepping.header
    },
    isMobile() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) return true
      return false
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  methods: {
    toggleLogin() {
      this.lightBoxOpen = !this.lightBoxOpen
    },
    logout() {
      this.$store.dispatch('auth/POST_LOGOUT')
    },
    showElement(val) {
      this.childrens = val
    },
    returnmenu() {
      this.childrens = null;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    openAccountMenu() {
      this.accountMenuOpen = !this.accountMenuOpen
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.nav {
  display: flex;
  z-index: 100;

  @include teq-breakpoint($medium) {
    align-items: center;
  }

  &__list {
    display: flex;
    //flex: 1;
    flex-direction: column;
    //margin-top: 10px;

    @include teq-breakpoint($medium) {
      align-items: center;
      background: white;
      flex-direction: row;
      justify-content: center;
      max-width: calc(100% - 186px);
      width: 100%;
    }

    ul {
      display: flex;
      padding: 0 30px;
      //padding: 10px 0;
      @include teq-breakpoint($medium) {
        align-items: center;
        padding: 0;
      }

      &:nth-child(1) {
        flex: 1;
        flex-direction: column;

        @include teq-breakpoint($medium) {
          flex-direction: row;
        }
      }
    }
  }

  li {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0;

    @include teq-breakpoint($medium) {
      align-content: center;
      align-items: center;
      justify-content: center;
    }

    &:first-child {
      align-items: flex-start;
      flex: 2;
    }

    &:last-child {
      @include teq-breakpoint($medium) {
        margin-right: 10px;
      }
    }
  }

  .top-link a {
    &:hover {
      color: $orange;
    }
  }

  .top-link-title {
    font-family: $f-graphie-bold;
    font-size: 1.3rem;
    line-height: 1em;
    text-align: center;

    &:hover {
      color: $orange;
    }

    &.-open {
      color: $orange;
    }
  }

  .icon {
    height: 2rem;
    margin: 0 auto;
    width: 100%;

    @include teq-breakpoint($medium) {
      width: 8rem;
    }
  }

  .nav__right {
    border-top: 1px solid #ddd;
    bottom: 0;
    justify-content: center;
    padding: 0;
    position: absolute;
    width: 100%;

    @include teq-breakpoint($medium) {
      border: 0;
      justify-content: flex-end;
      position: initial;
      width: auto;
    }

    li {
      box-sizing: border-box;
      max-width: 33.3%;
      padding: 1.1rem 0;
      width: 33.3%;

      @include teq-breakpoint($large) {
        max-width: initial;
        padding: 1.1rem 2.4rem;
        width: auto;
      }

      &:nth-child(1) {
        border-left: 1px solid #ddd;
      }

      &:nth-child(2) {
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
      }

      &:nth-child(3) {
        @include teq-breakpoint($large) {
          border-right: 1px solid #ddd;
          max-width: 9rem;
        }
      }

      a {
        @include font-size(11px);

        color: black;
        font-family: $f-graphie-book;

        &:hover {
          color: $orange;
        }
      }
    }
  }
}

.links__anchor {
  padding: 5px 15px;
  position: relative;

  @include teq-breakpoint($small) {
    padding: 5px 10px 0 10px;
  }

  svg {
    @include transition(0.3s ease all);
    @include rotate(180deg);

    height: 9px;
    left: 10px;
    position: absolute;
    top: 9px;
    width: 10px;

    @include teq-breakpoint($small) {
      position: relative;
      right: -10px;
      top: 0;
    }

    .active & {
      @include rotate(-90deg);
    }
  }

  span {
    color: black;
    font-family: $f-graphie-book;
    margin-left: 25px;

    @include font-size(16px);
  }
}

.child {
  flex-direction: column;
  padding: 0 !important;

  .links--current-page::after {
    width: 0;
  }

  li {
    font-family: $f-graphie-book;
    padding-top: 20px;
  }

  @include teq-breakpoint($medium) {
    display: none;
  }
}

.desktop {
  display: none !important;

  @include teq-breakpoint($medium) {
    display: flex !important;
  }
}

.mobile {
  display: flex !important;
  flex: 1;
  flex-direction: column;

  @include teq-breakpoint($medium) {
    display: none !important;
  }
}

.just-mobile {
  flex: 1;
  flex-direction: column;
}

.mobile__links {
  padding-top: 15px;
}

.-is-hidden {
  height: 0;
  overflow: hidden;
  transition: 0.4s;
}

.account-tab {
  cursor: pointer;
  overflow: visible;

  @include teq-breakpoint($medium) {
    position: relative;
  }
}

.account-menu {
  background: #f6f6f6;
  bottom: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 1rem 2.8rem;
  position: absolute;
  right: 0;
  top: -16rem;
  transition: 0.4s;
  width: calc(100vw - 6rem);
  z-index: 100;

  @include teq-breakpoint($large) {
    background: #fff;
    padding: 1rem 2rem;
    top: calc(100% + 12px);
    width: 23rem;
  }

  &.-open {
    border: 1px solid #ddd;
    border-top: 0;
    min-height: 19rem;

    @include teq-breakpoint($large) {
      margin-right: -25px;
      min-height: 11.5rem;
    }
  }
}

.welcome-msg {
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  font-family: $f-graphie-bold;
  font-size: 1.1rem;
  line-height: 1.8rem;
  margin-bottom: 3.5rem;
  padding-bottom: 1rem;

  @include teq-breakpoint($large) {
    margin-bottom: 1.2rem;
  }
}

.link,
.logout {
  color: #000;
  cursor: pointer;
  font-family: $f-graphie-book;
  line-height: 1.8rem;
  margin-bottom: 3rem;

  @include teq-breakpoint($large) {
    margin-bottom: 0.8rem;
  }
}

.logout-button {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.icon-logout {
  display: block;
  height: 1.3rem;
  width: 1.4rem;
}

.btn-label {
  font-size: 1.2rem !important;
  width: 50%;
}

.loggedin {
  @include teq-breakpoint($large) {
    position: relative;
  }

  &::before {
    background: #72c293;
    border-radius: 50%;
    content: '';
    height: 0.8rem;
    left: 51%;
    position: absolute;
    top: 41%;
    width: 0.8rem;

    @include teq-breakpoint($large) {
      left: 56%;
    }
  }
}

.open-submenu {
  cursor: pointer;
  height: 100%;
  left: 33.3%;
  position: absolute;
  top: 0;
  width: 33.3%;

  @include teq-breakpoint($large) {
    height: calc(100% + 2rem);
    left: -2.2rem;
    overflow: visible;
    top: -1rem;
    width: calc(100% + 4.4rem);
  }
}

.arrow {
  bottom: 1.4rem;
  fill: #000;
  height: 6.6px;
  position: absolute;
  right: 0.9rem;
  transform: rotate(90deg);
  width: 4px;

  @include teq-breakpoint($large) {
    right: 1.1rem;
  }
}

.profile-link {
  font-size: 1.2rem !important;
}
</style>
